/*
    Monday Task: 8478222625 - Buy Button Profile Listing
*/

import React from "react";
import { Table } from "reactstrap";
import { Sort, handleSort } from "../../../utils/commonFunctions";
import ProfileTableData from "./ProfileTableData";

const ProfileTable = ({ profileData, sort, setSort, setSortOrder, sortOrder, user }) => {
    return (
        <div className="col p-0">
            <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                    <tr>
                        <th scope="col" className="pl-3 pr-3">
                            Profile Name
                        </th>
                        <th scope="col" className="pl-1 pr-1">
                            Products
                        </th>
                        {/* Monday Task: 8899629353 - Added Store Name and Store Vanity URL Columns on Buy Button Profile Listing */}
                        <th scope="col" className="pl-1 pr-1">
                            Store Name
                        </th>
                        <th scope="col" className="pl-1 pr-1">
                            Store Vanity URL
                        </th>
                        <th scope="col" className="pl-1 pr-1">
                            <Sort
                                onClick={() => handleSort(sort, "created_at", setSortOrder, setSort)}
                                sortingOrder={sortOrder}
                                column="created_at">
                                Date Created
                            </Sort>
                        </th>
                        <th scope="col" className="pl-1 pr-1">
                            <Sort
                                onClick={() => handleSort(sort, "updated_at", setSortOrder, setSort)}
                                sortingOrder={sortOrder}
                                column="updated_at">
                                Date Updated
                            </Sort>
                        </th>
                        <th scope="col" className="pl-1 pr-1">
                            User
                        </th>
                        <th scope="col" className="pl-1 pr-1">
                            Button Color
                        </th>
                        <th scope="col" className="pl-1 pr-1">
                            Button Text
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {profileData?.map(profileRowData => (
                        <ProfileTableData key={profileRowData?.id} profileRowData={profileRowData} />
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default ProfileTable;
